import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'accent' | 'ghost' | 'danger' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  icon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading,
  icon,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-background disabled:opacity-50 disabled:cursor-not-allowed active:scale-95';
  const variants = {
    primary: 'bg-primary hover:bg-primary-hover text-white shadow-lg shadow-primary/25',
    secondary: 'bg-secondary hover:bg-secondary-hover text-white shadow-lg shadow-secondary/25',
    accent: 'bg-accent hover:bg-accent-hover text-white shadow-lg shadow-accent/25',
    ghost: 'hover:bg-card text-text-secondary hover:text-text-primary',
    danger: 'bg-red-500 hover:bg-red-600 text-white',
    outline: 'border border-card bg-transparent hover:bg-card text-text-primary'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 text-sm',
    lg: 'h-12 px-6 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-143">
      {isLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-144" /> : icon ? <span className="mr-2" data-id="element-145">{icon}</span> : null}
      {children}
    </button>;
}